import { Tabs, TabsList, TabsTrigger } from "@tellescope/ui";
import { useTranslation } from "react-i18next";

import type { TemplateEditorTab } from "./types";

export interface ModeTabsProps {
  activeTab: TemplateEditorTab;
  onTabChange: (tab: TemplateEditorTab) => void;
}

const TABS: TemplateEditorTab[] = ["text", "html"];

/** Text / HTML switcher. Text persists as `richtext`; HTML persists as `html`. */
export const ModeTabs = ({ activeTab, onTabChange }: ModeTabsProps) => {
  const { t } = useTranslation("templates");
  const labels: Record<TemplateEditorTab, string> = {
    text: t("Text"),
    html: t("HTML"),
  };

  return (
    <Tabs
      value={activeTab}
      onValueChange={(value) => {
        const tab = TABS.find((candidate) => candidate === value);
        if (tab) onTabChange(tab);
      }}
    >
      <TabsList>
        {TABS.map((tab) => (
          <TabsTrigger key={tab} value={tab}>
            {labels[tab]}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
